import { render, staticRenderFns } from "./ProductBox.vue?vue&type=template&id=a220154a&scoped=true&"
import script from "./ProductBox.vue?vue&type=script&lang=js&"
export * from "./ProductBox.vue?vue&type=script&lang=js&"
import style0 from "./ProductBox.vue?vue&type=style&index=0&id=a220154a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a220154a",
  null
  
)

export default component.exports